import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import orgReducer from './orgSlice';
import langReducer from './langSlice';
import cartReducer from './cartSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    org: orgReducer,
    lang: langReducer,
    cart: cartReducer,
  },
});

export default store;
